import { extendTheme } from "@chakra-ui/react";

// Or export `extendBaseTheme` if you only want the default Chakra theme tokens to extend (no default component themes)
export const customTheme = extendTheme({
  initialColorMode: 'dark',
  useSystemColorMode: false,
  components: {
    Divider: {
      baseStyle: {
        pt: '4',
        mb: '4'
      }
    },
    Heading:
    {
      baseStyle: {
        fontFamily: "Sofia Sans Extra Condensed Variable",
        fontWeight: "400",
      },
      variants:
      {
        inline: {
          fontFamily: "Roboto",
          fontWeight: "400",
          textTransform: "uppercase",
          fontSize: "1.1em",
          pb:'0.75em'
        }
      }
    }
  }
})